import React from 'react';
import { useRoutes } from 'hookrouter';
import ForgotCredentialsPage from 'pages/olb/forgotCredentials';
import ForgotPasswordPage from 'pages/olb/forgotPassword';
import ForgotUsernamePage from 'pages/olb/forgotUsername';
import FindMemberPage from '../pages/olb/findMember';

const routes = {
  '/forgot-credentials': () => <ForgotCredentialsPage />,
  '/forgot-password': () => <ForgotPasswordPage />,
  '/forgot-username': () => <ForgotUsernamePage />,
  '/sign-up': () => <FindMemberPage />
};

const OLBArea = () => {
  return useRoutes(routes);
};

export default OLBArea;
